// In App.js, wrap components that require Authentication with this component
import React from "react";
import {Outlet} from "react-router-dom";
import {useKeycloak} from "@react-keycloak/web";

const RequireAuth = () => {
    // NEW CODE START
    const {keycloak, initialized} = useKeycloak();
    const allowed = keycloak.authenticated;

    React.useEffect(() => {
        if (initialized && !keycloak.authenticated) {
            keycloak.login();
        }
    }, [initialized, keycloak]);

    // Show loading while Keycloak initializes
    if (!initialized) {
        return <div style={{padding: '20px', textAlign: 'center'}}>Loading...</div>;
    }
    // NEW CODE END

    return (
        <>
            {allowed === true && <Outlet/>}
        </>
    )
}

export default RequireAuth